import { createSlice } from "@reduxjs/toolkit";
import storage from "@/services/storage";
import { getParsedJson } from "@/services/generic.methods";
import config from "@/config";

export const generalReducer = createSlice({
  name: "general",
  initialState: {
    language: storage.getItem("language") || "en-US",
    host: null,
    theme: {
      mode: "default_theme",
      selectedPrimary: "primary_1",
      selectedSecondary: "primary_1",
      customPrimary: {},
      customSecondary: {},
    },
    ssoLoading: true,
    timezones: [],
    enableSMSForNonOptedLeads: true,
    hostMetaInfo: {
      hostLogo:
        "https://www.apexchat.com/wp-content/uploads/2019/09/ApexChat-logo-169x90-2.png",
      hostName: "Live Chat - Default",
    },
    countriesOptions: [],
    statesOptions: [],
    leadOriginTypes: [],
  },
  reducers: {
    /**
     * @name @login
     * @description login reducer to call login async API with axios instance
     * @requires ApiServices.get method, state and API payload
     **/
    setLanguage: (state, action) => {
      state.language = action.payload || "en-US";
      storage.setItem("language", state.language);
    },

    /**
     * @name @setGeneralState
     * @description to save general info in general state
     * @requires state,action for payload, Note: action.payload must be a object
     **/
    setGeneralState: (state, action) => {
      Object.keys(action.payload).forEach((key) => {
        state[key] = action.payload[key];
      });
    },
    /**
     * @name @setHostMetaInfo
     * @description to save general info in general state
     * @requires state,action for payload, Note: action.payload must be a object
     **/
    setCountriesOptions: (state, action) => {
      state.countriesOptions = action.payload;
    },
    setStatesOptions: (state, action) => {
      state.statesOptions = action.payload;
    },
    setHostMetaInfo: (state, action) => {
      state.hostMetaInfo = action.payload;
    },
    setTimezonesToState: (state, action) => {
      state.timezones = action.payload;
    },
    setEnableSMSForNonOptedLeadsToState: (state, action) => {
      state.enableSMSForNonOptedLeads = action.payload;
    },
    setLeadOriginTypesToState: (state, action) => {
      state.leadOriginTypes = action.payload;
    },
  },
});
export const {
  setLanguage,
  setGeneralState,
  setHostMetaInfo,
  setTimezonesToState,
  setEnableSMSForNonOptedLeadsToState,
  setCountriesOptions,
  setStatesOptions,
  setLeadOriginTypesToState,
} = generalReducer.actions;

export const stopPropogation = (ref) => (dispatch) => {
  /**
   * hide on clicked outside of the element
   */
  return new Promise((resolve, reject) => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        return resolve(true);
      }
    };
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  });
};

export const getHostMeta = () => async (dispatch) => {
  let host =
    config?.environment === "development"
      ? "https://crm.apexfeature9.xyz"
      : `https://${location?.host}`;

  if (host) {
    host = host.replace("crm.", "");
  }
  const src = `${host}/Handlers/HostLogo.ashx?ReturnTo=${host}`;

  let metaInfo = await fetch(src)
    .then((res) => res.text())
    .then(async (response) => {
      if (response) {
        response = response;
        let data = response.replace("HostMetaInfo=", "").replace(";", "");
        data = getParsedJson(data);
        return data;
      } else return null;
    });

  dispatch(setHostMetaInfo(metaInfo));
  return metaInfo;
};

export const selectShow = (state) => state.view;

export const selectLangauge = (state) => {
  return state.general.language;
};

export const getGeneralInfo = (state) => {
  return state.general;
};

export const getTimezones = (state) => {
  return state.general?.timezones;
};

export const getHostMetaInfo = (state) => {
  return state.general.hostMetaInfo;
};
export const getEnableSMSForNonOptedLeadsState = (state) => {
  return state.general.enableSMSForNonOptedLeads;
};

export const getSpecificGeneralInfo = (key) => (state) => {
  return state.general[key];
};

export const selectCountriesOption = (state) => {
  return state.general.countriesOptions;
};
export const selectStatesOption = (state) => {
  return state.general.statesOptions;
};
export const selectLeadOriginTypes = (state) => {
  return state.general.leadOriginTypes;
};
export default generalReducer.reducer;
